import { computed, watchEffect } from '@vue/composition-api';
import store from '@/store';
import { actions } from '@/controller';

const currentFrameIndex = computed(() => store.state.dataset.currentFrameIndex);

const saveCurrentItem = {
  text: 'Save Current Item',
  click: () => { store.dispatch.dataset.saveCurrentFrame(); },
  disabled: true,
};

const confirmCurrentItem = {
  text: 'Confirm Current Item',
  click: () => {
    if (currentFrameIndex.value === null) { return; }
    store.dispatch.dataset.setFrameStatus({ index: currentFrameIndex.value, status: 'confirmed' });
  },
  disabled: true,
};

const unconfirmCurrentItem = {
  text: 'Unconfirm Current Item',
  click: () => {
    if (currentFrameIndex.value === null) { return; }
    store.dispatch.dataset.setFrameStatus({ index: currentFrameIndex.value, status: 'pending' });
  },
  disabled: true,
};

// Update confirm menus depending on current item
watchEffect(() => {
  const { currentFrame } = store.getters.dataset;
  if (currentFrame === null) { return; }

  const confirmed = currentFrame.status === 'confirmed';
  confirmCurrentItem.disabled = confirmed;
  saveCurrentItem.disabled = confirmed;
  unconfirmCurrentItem.disabled = !confirmed;
});

export const item = {
  text: 'Current Item',
  menu_width: 250,
  disabled: true,
  menu: [
    // {
    //   text: 'Automatic Face Detection',
    //   click: () => { console.log('Automatic Face Detection'); },
    //   disabled: true,
    //   unimplemented: true,
    // },
    // {
    //   text: 'Automatic Pain Score',
    //   click: () => { console.log('Automatic Pain Score'); },
    //   disabled: true,
    //   unimplemented: true,
    // },
    // {
    //   text: 'Automatic FD/PS No Mask',
    //   click: () => { console.log('Automatic FD/PS No Mask'); },
    //   disabled: true,
    //   unimplemented: true,
    // },
    {
      text: 'Clear Scores',
      click: () => {
        if (currentFrameIndex.value === null) { return; }
        store.dispatch.dataset.clearScore(currentFrameIndex.value);
      },
      disabled: true,
    },
    {
      text: 'Clear Annotations',
      click: () => {
        if (currentFrameIndex.value === null) { return; }
        actions.clearAnnotations(currentFrameIndex.value);
      },
      disabled: true,
    },
    {
      text: 'Remove Current Item',
      click: () => {
        if (currentFrameIndex.value === null) { return; }
        actions.deleteFrame(currentFrameIndex.value);
      },
      disabled: true,
    },
    saveCurrentItem,
    confirmCurrentItem,
    unconfirmCurrentItem,
  ],
};
